import { modSelector } from "@src/store/slices/experienceBuilder/common/utils/modSelector";
import { EmbeddedMod } from "@src/store/slices/experienceBuilder/types";
import { createSelector } from "@reduxjs/toolkit";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";

export const getEmbeddedNodesFactory = (mod: EmbeddedMod) =>
  createSelector(experienceBuilderSlice.selectors.getEmbeddedNodes, (map) => {
    // When nodes from mod are available, we support mod switching, because
    // we have information about multiple nodes
    if ("nodes" in mod && mod.nodes.length > 0) {
      return mod.nodes;
    }
    // When falling back to live DOM info, we don't support mod switching, but
    // we do support access to original DOM HTML and src (for images)
    const selector = modSelector(mod);
    if (selector) {
      const node = map[selector];
      if (node) {
        return [node];
      }
    }
    return [];
  });
